import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxHalWebServicesModule } from '@ngx-hal/web-services';
import { NgxsModule } from '@ngxs/store';
import { ItemProfileState } from './spring/item-profile.state';
import { ItemResourceState } from './spring/item-resource.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([ItemResourceState, ItemProfileState])],
})
export class NgxHalStatesModule {
  public static forRoot(): ModuleWithProviders<NgxHalStatesModule> {
    return {
      ngModule: NgxHalStatesModule,
      providers: [...(NgxHalWebServicesModule.forRoot().providers ?? [])],
    };
  }
}
